import { render } from "./Modal.vue?vue&type=template&id=769fa92e"
import script from "./Modal.vue?vue&type=script&lang=js"
export * from "./Modal.vue?vue&type=script&lang=js"

import "./Modal.vue?vue&type=style&index=0&id=769fa92e&lang=less"

import exportComponent from "D:\\fuda\\司法鉴定\\web_sfjd\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__